"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CANCEL_ORDER = exports.GET_ORDER_STATUS = exports.CREATE_ORDER = void 0;
const helpers_1 = require("../../client/helpers");
exports.CREATE_ORDER = `
  mutation CreateOrder(
    $id: ID!
    $type: PurchaseOrderType!
    $redirect: PurchaseOrderRedirectParams
  ) {
    purchase {
      order {
        create(input: { id: $id, type: $type, redirect: $redirect }) {
          message
          entity {
            id
          }
        }
      }
    }
  }
`;
exports.GET_ORDER_STATUS = `
  query GetOrderStatus($id: ID!, $type: PurchaseType!) {
    purchase(filter: { id: $id, type: $type }) {
      status
    }
  }
`;
exports.CANCEL_ORDER = `
  mutation CancelOrder($id: ID!) {
    purchase {
      cancel(filter: { id: $id, type: SUBSCRIPTION }) {
        status
      }
    }
  }
`;
//# sourceMappingURL=purchase.queries.js.map